import getArticleChannelData from "../articles/getArticleChannelData";

export default function articleHasChannelDates(article, channelId) {
	return (
		getArticleChannelData(article, channelId, "announcementDate") ||
		getArticleChannelData(article, channelId, "releaseDate") ||
		getArticleChannelData(article, channelId, "takedownDate")
	);
}
